/**
 * Copyright (c) HashiCorp, Inc.
 */

import { hash } from '@ember/helper';

import type { TOC } from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';
import type { HdsDropdownListItemGenericSignature } from '@hashicorp/design-system-components/components/hds/dropdown/list-item/generic';
import type { FilterConfig, ToggleArgs } from '../../filter-bar';

export interface FilterBarFilterGenericSignature {
  Args: {
    generic: ComponentLike<HdsDropdownListItemGenericSignature>;
    toggle?: (toggle: ToggleArgs) => void;
    applyFilter?: (name: string) => void;
    config?: FilterConfig;
    localConfig?: FilterConfig;
  };
  Blocks: {
    default: [
      {
        toggle?: (toggle: ToggleArgs) => void;
        applyFilter?: (name: string) => void;
        config?: FilterConfig;
        localConfig?: FilterConfig;
      },
    ];
  };
  Element: HTMLDivElement;
}

const FilterBarFilterGeneric: TOC<FilterBarFilterGenericSignature> = <template>
  {{#let @generic as |Generic|}}
    <Generic>
      {{yield
        (hash
          toggle=@toggle
          applyFilter=@applyFilter
          config=@config
          localConfig=@localConfig
        )
      }}
    </Generic>
  {{/let}}
</template>;

export default FilterBarFilterGeneric;
